import React, { useState, useEffect } from "react";
import Pages from "./pages";
import { useHistory } from "react-router-dom";
import { PropTypes } from 'prop-types';
import { connect } from "react-redux";
import {getCertificationAmountByAppId} from "../../redux/Actions/GetDocsActions"

const ContinueCertification = ({
  user,
  admin,
  type,
  appId,
  portNo,
  tid,
  companyId,
  renewalCount,
  getCertificationAmountbyId,
  certificationAmountId,
  merchantClass
  
}) => {

  const history = useHistory();

  const route = Pages(user, admin, type, renewalCount);


  // const goToNextStage = async () => {

  //   let newType = "";
  //   if (type === "pos_device_certification") {
  //     newType = "device";
  //   } else {
  //     newType = "application";
  //   }
  //   const certId = certificationAmountId ? certificationAmountId : localStorage.getItem("certification_amount_id")
  //   // const merchant_class = certificationAmountId ? certificationAmountId : localStorage.getItem("certification_amount_id")
 
  //   if (route !== false) {
  //     await getCertificationAmountbyId(appId)
  //     history.push({
  //       pathname: route,
  //       state: {
  //         id: appId,
  //         companyId: companyId,
  //         tid: tid,
  //         portNo: portNo,
  //         type: newType,
  //         amount_id: +certId,
  //         merchantClass: merchantClass
  //       },
  //     });
  //     // getCertificationAmountbyId(appId)
  //   }
   
  // };

const [shouldNavigate, setShouldNavigate] = useState(false);

const goToNextStage = () => {
  if (route !== false) {
    getCertificationAmountbyId(appId);
    setShouldNavigate(true);
  }
};

  useEffect(() => {
    if (shouldNavigate && (merchantClass || type === "pos_device_certification")) {
      let newType = "";
      if (type === "pos_device_certification") {
        newType = "device";
      } else {
        newType = "application";
      }
      
      const certId = certificationAmountId || localStorage.getItem("certification_amount_id");
      
      history.push({
        pathname: route,
        state: {
          id: appId,
          companyId: companyId,
          tid: tid,
          portNo: portNo,
          type: newType,
          amount_id: +certId,
          merchantClass: merchantClass
        },
      });
      
      setShouldNavigate(false);
    }
  }, [merchantClass, shouldNavigate]);

  return (
    <div>
      <div className="continue-sec">
        <button
          data-testid="continue-sec"
          className="continue-sec-btn"
          onClick={() => goToNextStage(user, admin, type)}
          disabled={route === false}
        >
          continue
        </button>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    certificationAmountByAppId: state.docs.certificationAmountByAppId,
    merchantClass: state.docs.merchantClass
   
  };
};
const mapDispatchToProps = (dispatch) => ({
  getCertificationAmountbyId: (id) => dispatch(getCertificationAmountByAppId(id)),
});



ContinueCertification.propTypes = {
  certificationAmountId: PropTypes.number,
  user: PropTypes.object,
  admin: PropTypes.object,
  type: PropTypes.string,
  appId: PropTypes.number,
  portNo: PropTypes.string,
  tid: PropTypes.string,
  companyId: PropTypes.number,
  renewalCount: PropTypes.number,
  merchantClass: PropTypes.string,
}

export default connect(mapStateToProps, mapDispatchToProps)(ContinueCertification);
